"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var platform_1 = tslib_1.__importDefault(require("platform"));
var TransportNames_1 = tslib_1.__importDefault(require("../../../common/constants/TransportNames"));
var Defaults = {
    internetUpUrl: 'https://internet-up.ably-realtime.com/is-the-internet-up.txt',
    jsonpInternetUpUrl: 'https://internet-up.ably-realtime.com/is-the-internet-up-0-9.js',
    /* Order matters here: the base transport is the leftmost one in the
     * intersection of baseTransportOrder and the transports clientOption that's
     * supported.  This is not quite the same as the preference order -- e.g.
     * xhr_polling is preferred to jsonp, but for browsers that support it we want
     * the base transport to be xhr_polling, not jsonp */
    defaultTransports: [
        TransportNames_1["default"].XhrPolling,
        TransportNames_1["default"].XhrStreaming,
        TransportNames_1["default"].JsonP,
        TransportNames_1["default"].WebSocket,
    ],
    baseTransportOrder: [
        TransportNames_1["default"].XhrPolling,
        TransportNames_1["default"].XhrStreaming,
        TransportNames_1["default"].JsonP,
        TransportNames_1["default"].WebSocket,
    ],
    transportPreferenceOrder: [
        TransportNames_1["default"].JsonP,
        TransportNames_1["default"].XhrPolling,
        TransportNames_1["default"].XhrStreaming,
        TransportNames_1["default"].WebSocket,
    ],
    upgradeTransports: [TransportNames_1["default"].XhrStreaming, TransportNames_1["default"].WebSocket],
};
/* If using IE8, don't attempt to upgrade from xhr_polling to xhr_streaming -
 * while it can do streaming, the low max http-connections-per-host limit means
 * that the polling transport is crippled during the upgrade process. So just
 * leave it at the base transport */
if (platform_1["default"].noUpgrade) {
    Defaults.upgradeTransports = [];
}
exports["default"] = Defaults;
